import APIUtils from '@spothero/utils/api';
import ObjectUtils from '@spothero/utils/object';
import ErrorUtils from 'utils/error-utils';

export const getFacilitiesByPackage = (id, params) => {
    return APIUtils.get(`/facilities/rates/event-packages/${id}/`, params)
        .then(response => {
            try {
                // This transforms the monolith response into a more unified facility summary
                // (e.g. OBJECT_COMMON_FACILITY_SUMMARY), with blank fields where there are
                // gaps in data.
                const packageData = ObjectUtils.camelizeKeys(
                    response.data.data
                );

                const {eventPackage, results} = packageData;
                const {eventCount} = eventPackage;

                const transformedResults = results.map(item => {
                    const {
                        facilityId,
                        title,
                        distance: linearMeters,
                        latitude,
                        longitude,
                        defaultImageUrl,
                        totalPrice,
                        currency: {type: currencyType},
                        ratingInfo: {
                            numberOfRatings: count,
                            starRating: average,
                        },
                        amenitiesFull,
                    } = item;

                    const amenities =
                        amenitiesFull?.map(amenity => ({
                            type: amenity.slug,
                            displayName: amenity.name,
                        })) || [];

                    return {
                        isV2: true,
                        spotId: `${facilityId}`,
                        title,
                        selectedRate: {
                            fullUrl: `/checkout/${facilityId}/event-packages/${id}/`,
                            advertisedPrice: {
                                currencyCode: currencyType.toUpperCase(),
                                value: totalPrice / eventCount,
                            },
                            totalPrice: {
                                currencyCode: currencyType.toUpperCase(),
                                value: totalPrice,
                            },
                            amenities,
                        },
                        rating: {
                            average,
                            count,
                        },
                        images: defaultImageUrl
                            ? [
                                  {
                                      id: '',
                                      urlTemplate: defaultImageUrl,
                                      url: defaultImageUrl,
                                      altText: `Photo of ${title}`,
                                  },
                              ]
                            : [],
                        addresses: [
                            {
                                latitude,
                                longitude,
                                // dummy info
                                id: '',
                                city: '',
                                country: '',
                                postalCode: '',
                                state: '',
                                streetAddress: '',
                                timeZone: '',
                            },
                        ],
                        availability: {
                            available: true,
                            unavailableReasons: [],
                        },
                        distance: {
                            linearMeters,
                        },
                        facilityType: 'unknown',
                        allAmenities: amenities,
                    };
                });

                return transformedResults;
            } catch (error) {
                return Promise.reject(new Error('Response shape unexpected.'));
            }
        })
        .catch(error => {
            ErrorUtils.sendSentryError(error);

            return Promise.reject(ErrorUtils.formatError(error));
        });
};
